import { ReactElement } from 'react'
import { useParams } from 'react-router-dom'
import useUIStore from 'src/state/stores/ui'
import SceneOverlayChip from './SceneOverlayChip'

/**
 * How many elements the agent marked in the scene (`mark_elements`); a click hides or shows the
 * marking, the x removes it. Shown only while something is marked.
 */
const MarkedElementsChip = (): ReactElement | null => {
  const { projectId } = useParams()
  const count = useUIStore(state =>
    projectId ? state.aiChatMarkedElementGuidsByProject[projectId]?.length ?? 0 : 0,
  )
  const hidden = useUIStore(state =>
    projectId ? state.aiChatMarkingHiddenByProject[projectId] ?? false : false,
  )
  const setAiChatMarkedElementGuids = useUIStore(state => state.setAiChatMarkedElementGuids)
  const toggleAiChatMarkingHidden = useUIStore(state => state.toggleAiChatMarkingHidden)

  if (!projectId || count === 0) return null

  return (
    <SceneOverlayChip
      label={count === 1 ? '1 Element markiert' : `${count} Elemente markiert`}
      hidden={hidden}
      onToggleHidden={() => toggleAiChatMarkingHidden(projectId)}
      onRemove={() => setAiChatMarkedElementGuids(projectId, [])}
      data-cy="ai-chat-marked-elements"
    />
  )
}

export default MarkedElementsChip
